import type { HTMLAttributes } from 'react';
import { LoadingCircle as Circle } from './LoadingCircle.style';

type Props = Pick<HTMLAttributes<HTMLSpanElement>, 'className'>;

export const LoadingCircle = ({ className }: Props) => (
  <Circle role="progressbar" className={className} />
);
